<div mat-dialog-content>
    <div class="city-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-genCityNew (closeDialog)="onClose()" [cityId]="cityId"></app-genCityNew>
</div>